/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import auth from '@/auth/authService'

import { DEFAULT_DOMAIN, NAME_FOR_DOMAIN } from './config/commonConfig'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [
    {
    // =============================================================================
    // Auth LAYOUT ROUTES
    // =============================================================================
      path: '',
      component: () => import('./layouts/auth/Auth.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          name: 'login',
          component: () => import('./views/pages/glotLogin/Login.vue'),
          props: true
        },
        {
          path: '/verificationSuccess',
          name: 'verificationSuccess',
          component: () => import('./views/pages/glotLogin/Login.vue'),
          props: true 
        },
        {
          path: '/register',
          name: 'register',
          component: () => import('./views/pages/glotLogin/Register.vue')
        },
        {
          path: '/forgotPassword',
          name: 'forgotPassword',
          component: () => import('./views/pages/glotLogin/ForgotPassword.vue'),
          meta:{
            canBackLogin: true
          }
        },
        {
          path: '/reset-password',
          name: 'newPassword',
          component: () => import('./views/pages/glotLogin/ConfirmNewPassword.vue'),
          meta:{
            canBackLogin: true
          }
        },
        {
          path: '/register/new',
          name: 'registerAcc',
          component: () => import('./views/pages/glotLogin/RegisterAcc.vue'),
          meta: {
            canBackLogin: true
          }
        }
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/logout',
          name: 'logout',
          component: () => import('./views/pages/glotLogin/Logout.vue')
        },
        {
          path: "/re-authenticate",
          name: 'reAuthen',
          component: () => import('./views/pages/glotLogin/ReAuthenticate.vue')
        },
        {
          path: '/login-success',
          name: 'loginSuccess',
          component: () => import('./views/pages/demoLogin/Demo.vue')
        },
        {
          path: '/sent-verification',
          name: 'sentVerification',
          component: () => import('./views/pages/glotLogin/ConfirmationSent.vue')
        },
        {
          path: '/sent-email-register',
          name: 'sentEmailRegister',
          component: () => import('./views/pages/glotLogin/ConfirmRegister.vue')
        },
        {
          path: '/changedPass',
          name: 'changedPass',
          component: () => import('./views/pages/glotLogin/ChangePasswordSuccess.vue')
        },
        {
          path: '/sentPassword',
          name: 'sentPassword',
          component: () => import('./views/pages/glotLogin/NotiSendEmailPass.vue')
        },
        {
          path: '/email-confirmation-success',
          name: 'emailConfirmationSuccess',
          component: () => import('./views/pages/glotLogin/VerificationSuccess.vue')
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue')
        },
        {
          path: '/auth/facebook/callback',
          name: 'callback-facebook',
          component: () => import('@/views/pages/Callback.vue')
        },
        {
          path: '/auth/google/callback',
          name: 'callback-google',
          component: () => import('@/views/pages/Callback.vue')
        },
        {
          path: '/auth/apple/callback',
          name: 'callback-apple',
          component: () => import('@/views/pages/Callback.vue')
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ]
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

router.beforeEach((to, from, next) => {
  if (to.name === 'login' || to.name === 'logout' || to.name === 'register') {
    const searchParams = new URLSearchParams(to.query)
    if (!localStorage.getItem('continueDomain')) {
      localStorage.setItem('continueDomain', DEFAULT_DOMAIN)
    }
    const isLogined  = auth.isAuthenticated() && to.name === 'login'
    if (to.name === 'register' && to.query.ref) {
      localStorage.setItem('referal', to.query.ref)
      searchParams.delete('ref')
      router.replace(`${to.path}?continue=${DEFAULT_DOMAIN}${searchParams.toString() ? `&${  searchParams.toString()}` : ''}`)
    }

    if (to.query.continue || to.query.redirect_uri) {
      try {
        const url = to.query.continue || to.query.redirect_uri
        let hasValidDomain = false
        NAME_FOR_DOMAIN.map(domain => {
          if (domain.prefix && url.startsWith(domain.prefix)) {
            hasValidDomain = true
          }
          if (domain.contain && url.includes(domain.contain)) {
            hasValidDomain = true
          }
        })
        if (!hasValidDomain) {
          searchParams.delete('continue')
          searchParams.delete('redirect_uri')
          if (isLogined) {
            window.location.href = `${DEFAULT_DOMAIN}?token=${localStorage.getItem('accessToken')}${searchParams.toString() ? `&${  searchParams.toString()}` : ''}`
          } else {
            router.replace(`${to.path}?continue=${DEFAULT_DOMAIN}${searchParams.toString() ? `&${  searchParams.toString()}` : ''}`)
          }
        } else if (isLogined) {
          localStorage.setItem('continueDomain', `${to.query.continue || to.query.redirect_uri}${to.query.extId ? `&extId=${ to.query.extId}` : ''}`)
          window.location.href = `${to.query.continue || to.query.redirect_uri}?token=${localStorage.getItem('accessToken')}${searchParams.toString() ? `&${  searchParams.toString()}` : ''}`
        } else {
          localStorage.setItem('continueDomain', `${to.query.continue || to.query.redirect_uri}${to.query.extId ? `&extId=${ to.query.extId}` : ''}`)
        }
      } catch (err) {
        searchParams.delete('continue')
        searchParams.delete('redirect_uri')
        if (isLogined) {
          window.location.href = `${DEFAULT_DOMAIN}?token=${localStorage.getItem('accessToken')}${searchParams.toString() ? `&${  searchParams.toString()}` : ''}`
        } else {
          router.replace(`${to.path}?continue=${DEFAULT_DOMAIN}${searchParams.toString() ? `&${  searchParams.toString()}` : ''}`)
        }
      }
    } else {
      searchParams.delete('continue')
      searchParams.delete('redirect_uri')
      if (isLogined) {
        window.location.href = `${DEFAULT_DOMAIN}?token=${localStorage.getItem('accessToken')}${searchParams.toString() ? `&${  searchParams.toString()}` : ''}`
      } else {
        router.replace(`${to.path}?continue=${DEFAULT_DOMAIN}${searchParams.toString() ? `&${  searchParams.toString()}` : ''}`)
      }
    }
  }
  next()
})

export default router
